import React from "react";
import {
  IconBuildingSkyscraper,
  IconFlame,
  IconPlane,
  IconSchool,
  IconShield,
} from "@tabler/icons-react";
import { useLocation, useNavigate } from "react-router-dom";

const iconMap = {
  IconUserShield: IconShield,
  IconFlame: IconFlame,
  IconBuildingSkyscraper: IconBuildingSkyscraper,
  IconPlane: IconPlane,
  IconSchool: IconSchool,
};

function NavOptionDropdownItem({ dropdownItem, currentLanguage, itemClassName }) {
  const location = useLocation();
  const navigate = useNavigate();

  const handleItemClick = (path) => {
    const [basePath, hash] = path.split("#");

    const scrollToHash = () => {
      const section = document.getElementById(hash);
      if (section) {
        const yOffset = -100;
        const y = section.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    };

    if (location.pathname === basePath && hash) {
      setTimeout(scrollToHash, 100);
    } else {
      navigate(basePath);
      setTimeout(scrollToHash, 500);
    }
  };

  const handleKeyDown = (event, path) => {
    if (event.key === "Enter") {
      handleItemClick(path);
    }
  };

  const IconComponent = iconMap[dropdownItem.icon];
  const label = dropdownItem.label[currentLanguage];
  const isIndustriesItem = itemClassName === "Industries";
  const hasVisibleItems = dropdownItem.subitems?.length > 0 || dropdownItem.path;

  if (!hasVisibleItems) return null;

  return (
    <div
      className={`desktop-dropdown-nav-option ${
        location.pathname === dropdownItem.path ? "active-dropdown-item" : ""
      } 
      ${isIndustriesItem ? "nav-item-industries" : ""} dropdown-item-${label
        .toLowerCase()
        .replace(/\s+/g, "-")}`}
      onClick={() => handleItemClick(dropdownItem.link || dropdownItem.path)}
      onKeyDown={(event) => handleKeyDown(event, dropdownItem.link || dropdownItem.path)}
      tabIndex="0"
    >
      <div className="dropdown-subheader-container">
        {IconComponent && <IconComponent size={26} />}
        <span>{label}</span>
        {dropdownItem.description && (
          <p className="solution-description">
            {dropdownItem.description[currentLanguage]}
          </p>
        )}
      </div>

      {dropdownItem.subitems && dropdownItem.subitems.map((subItem, index) => {
        const subLabel = subItem.label[currentLanguage];
        return (
          <div
            key={subItem.link || subItem.path || subLabel}
            className={`sub-dropdown-item sub-dropdown-item-${subLabel
              .toLowerCase()
              .replace(/\s+/g, "-")}`}
            onClick={() => handleItemClick(subItem.link)}
            onKeyDown={(event) => handleKeyDown(event, subItem.link)}
            tabIndex="0"
          >
            {subLabel}
          </div>
        );
      })}
    </div>
  );
}

export default NavOptionDropdownItem;
